import {
  DatePickerInput,
  DropdownMultiSelectInput,
  SearchInput,
} from '@aslanpay/portal-common-lib';
import { Flex, Select } from '@chakra-ui/react';

import { TimeFilterOption } from '../TheRoar.types';

import { TheRoarFiltersProps } from './TheRoarFilters.types';
import PridesTreeSelect from './PridesTreeSelect';

const TIME_OPTIONS: { value: TimeFilterOption; label: string }[] = [
  { value: 'allTime', label: 'All time' },
  { value: 'thisWeek', label: 'This week' },
  { value: 'thisMonth', label: 'This month' },
  { value: 'last30Days', label: 'Last 30 days' },
  { value: 'lastQuarter', label: 'Last quarter' },
  { value: 'thisYear', label: 'This year' },
  { value: 'customRange', label: 'Custom range' },
];

function TheRoarFilters({
  groupTree,
  valueOptions,
  selectedGroupIds,
  selectedValueIds,
  timeOption,
  customFrom,
  customTo,
  searchQuery,
  onGroupsChange,
  onValuesChange,
  onTimeOptionChange,
  onCustomFromChange,
  onCustomToChange,
  onSearchChange,
}: TheRoarFiltersProps) {
  return (
    <Flex align="center" gap="8px">
      <Flex flex="1">
        <PridesTreeSelect tree={groupTree} selected={selectedGroupIds} onChange={onGroupsChange} />
      </Flex>

      <Flex flex="1">
        <DropdownMultiSelectInput
          placeholder="All values"
          selected={selectedValueIds}
          options={valueOptions}
          onChange={onValuesChange}
          isSearchable
          isSelectAllEnabled
          selectAllDisplayLabel="All values"
        />
      </Flex>

      <Select
        flex="1"
        h="50px"
        value={timeOption}
        onChange={(e) => onTimeOptionChange(e.target.value as TimeFilterOption)}
        borderRadius="8px"
        borderColor="brand.lightGray1"
        fontSize="sm"
      >
        {TIME_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>

      {timeOption === 'customRange' && (
        <>
          <Flex flex="1">
            <DatePickerInput
              placeholder="From"
              defaultValue={customFrom}
              onChange={onCustomFromChange}
              onBlur={() => {}}
            />
          </Flex>
          <Flex flex="1">
            <DatePickerInput
              placeholder="To"
              defaultValue={customTo}
              onChange={onCustomToChange}
              onBlur={() => {}}
              minDate={customFrom ? new Date(customFrom) : undefined}
            />
          </Flex>
        </>
      )}

      <Flex flex={timeOption === 'customRange' ? '1' : '2'}>
        <SearchInput
          placeholder="Search recognitions"
          searchQuery={searchQuery}
          setSearchQuery={onSearchChange}
          debounceDelay={0}
          w="full"
        />
      </Flex>
    </Flex>
  );
}

export default TheRoarFilters;
